import '../shared'
import { addi18n } from '../i18n/index'
import Router from 'live/services/router'
import authorizations from 'live/services/authorization'

const APP_LINKS = ['/app/static_data_manager', '/app/kpi_drilling']

export const preventAppUsage = (permission: string[]): void => {
    if (isAllowed(permission)) return

    const callback = function(): void {
        const menus = document.getElementsByClassName('navigation apps')

        Array.from(menus).forEach(element => {
            APP_LINKS.forEach(APP_LINK => {
                const a = element.querySelector(`[href="${APP_LINK}"]`)
                if (!a) return

                const li = a.closest('li')
                if (!li) return
                li.remove()
            })
        })
    }

    const observer = new MutationObserver(callback)

    document.addEventListener('DOMContentLoaded', () => {
        const navigation = document.getElementById('main-navigation')
        if (!navigation) return console.error('Main navigation not found')

        observer.observe(navigation, {
            childList: true,
            subtree: true
        })
    })

    Router.addChangeListener(() => {
        const path = window.location.pathname

        APP_LINKS.forEach(APP_LINK => {
            if (path.includes(APP_LINK)) {
                window.history.replaceState(null, '', '/')
                window.location.hash = '#'
            }
        })
    })
}

const isAllowed = (permission: string[]): boolean => {
    try {
        if (authorizations === undefined || !authorizations.isAuthenticated) throw new Error('User not authenticated')

        if (authorizations.admin || authorizations.superAdmin) return true // Uncomment this line to allow admin users to access the app

        if (permission == null || permission.length === 0) return true

        const permissions = Object.keys(authorizations?.permissions ?? {})

        if (permissions.length === 0 || permissions.some(p => permission.includes(p))) return true
    } catch (e) {
        console.error('Error checking auth', e)

        return false
    }
}

preventAppUsage([
    'superAdmin',
    'admin',
    'ADMIN',
    'OGPERFORMANCE_MANAGE_KPI',
    'OGPERFORMANCE_ADMINISTRATE_KPI',
    'OGPERFORMANCE_VIEW_KPI'
])
require('./widgets')
require('./staticdatamanagerapp')
require('./staticdatamanagerapp/wellInterventions')

addi18n()
